function safeWindow(fn) {
  if (typeof window !== 'undefined') {
    return fn(window);
  }
  return {};
}

export default safeWindow;
